<template>
  <f7-page name="user-settings" :page-content="false">
    <f7-progressbar v-if="isLoading" color="green" infinite class="progressbar-top" key="1"></f7-progressbar>
    <f7-navbar >
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('UserSettings') }}</f7-nav-title>
      <f7-nav-right>
        <f7-link v-if="currentTab === 'tab-user'" @click="onSubmitProfile" href="#" icon-f7="checkmark_alt"></f7-link>
        <f7-link v-else-if="currentTab === 'tab-password'" @click="onSubmitPassword" href="#" icon-f7="checkmark_alt"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar top>
      <f7-link tab-link="#tab-user" tab-link-active>{{ $t('Profile') }}</f7-link>
      <f7-link tab-link="#tab-password">{{ $t('Password') }}</f7-link>
    </f7-toolbar>

    <f7-tabs animated>
      <f7-tab id="tab-user" class="page-content" tab-active @tab:show="currentTab='tab-user'">

        <f7-list no-hairlines form @submit.prevent="onSubmitProfile">
          <input type="submit" hidden>
          <f7-list-input
              floating-label
              type="text"
              name="customerName"
              :label="$t('CustomerName')"
              :placeholder="$t('CustomerName')"
              v-model:value="customerName"
              disabled
          >
            <template #media>
              <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              required
              validate
              name="firstName"
              :label="$t('FirstName')"
              :placeholder="$t('FirstName')"
              v-model:value="firstName"
          >
            <template #media>
              <f7-icon icon="f7-icons  text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              required
              validate
              name="subName"
              :label="$t('LastName')"
              :placeholder="$t('LastName')"
              v-model:value="lastName"
          >
            <template #media>
              <f7-icon icon="f7-icons  text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="email"
              required
              validate
              name="email"
              :label="$t('Email')"
              :placeholder="$t('Email')"
              v-model:value.trim="email"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-email text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="tel"
              required
              validate
              name="phone"
              :label="$t('Phone')"
              :placeholder="$t('Phone')"
              v-model:value.trim="phone"
              :error-message="$t('OnlyNumbers')"
              pattern="[0-9]*"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-mobile text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>

          <f7-list-item
              class="item-input custom-smart-select-wrapper"
              :title="$t('Country')"
              smart-select
              :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
              :key="'keyCountryList'+keyCountryList"
              disabled
          >
            <template #media>
              <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
            <select name="countryList" v-model="countryCode">
              <option
                  v-for="country in countryList"
                  :key="country.CountryCode"
                  :value="country.CountryCode"
              >{{country.Country}}</option>
            </select>
          </f7-list-item>
          <f7-list-item
              class="item-input custom-smart-select-wrapper"
              :title="$t('TimeZone')"
              smart-select
              :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
              :key="'keyTimeZonesList'+keyTimeZonesList"
          >
            <template #media>
              <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
            <select name="countryList" v-model="timeZone">
              <option
                  v-for="timeZone in timeZonesList"
                  :key="timeZone.code"
                  :value="timeZone.code"
              >{{timeZone.name}}</option>
            </select>
          </f7-list-item>
          <f7-list-input
              floating-label
              type="text"
              name="address"
              :label="$t('Address')"
              :placeholder="$t('Address')"
              v-model:value.trim="address"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-position text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              name="address1"
              :label="$t('Address')+' '+2"
              :placeholder="$t('Address')+' '+2"
              v-model:value.trim="address1"
          >
            <template #media>
              <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              name="city"
              :label="$t('City')"
              :placeholder="$t('City')"
              v-model:value.trim="city"
          >
            <template #media>
              <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              name="state"
              :label="$t('StateProvince')"
              :placeholder="$t('StateProvince')"
              v-model:value.trim="state"
          >
            <template #media>
              <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              type="text"
              name="zipcode"
              :label="$t('ZipCode')"
              :placeholder="$t('ZipCode')"
              v-model:value.trim="zipcode"
          >
            <template #media>
              <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>

        </f7-list>
      </f7-tab>

      <f7-tab id="tab-password" class="page-content" @tab:show="currentTab='tab-password'">
        <f7-list no-hairlines form @submit.prevent="onSubmitPassword">
          <input type="submit" hidden>
          <f7-list-input
              floating-label
              :type="passwordTypeCurrent"
              name="currentPassword"
              :label="$t('CurrentPassword')"
              :placeholder="$t('CurrentPassword')"
              v-model:value="currentPassword"
              required
              validate

              validate-on-blur
          >
            <template #media>
              <f7-icon icon="f7-icons icon-password text-color-lightgray"></f7-icon>
            </template>
            <template #content-end>
              <div @click="switchVisability('passwordTypeCurrent')" class="margin-right link">
                <i class="f7-icons icon-view"
                   :class="{'text-color-gray' : passwordTypeCurrent === 'password', 'text-color-black' : passwordTypeCurrent === 'text'}"></i>
              </div>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              :type="passwordTypeNew"
              name="newPassword"
              :label="$t('NewPassword')"
              :placeholder="$t('NewPassword')"
              v-model:value.trim="newPassword"
              required
              validate

              validate-on-blur
              :minlength="6"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-password text-color-lightgray"></f7-icon>
            </template>
            <template #content-end>
              <div @click="switchVisability('passwordTypeNew')" class="margin-right link">
                <i class="f7-icons icon-view"
                   :class="{'text-color-gray' : passwordTypeNew === 'password', 'text-color-black' : passwordTypeNew === 'text'}"></i>
              </div>
            </template>
          </f7-list-input>
          <f7-list-input
              floating-label
              :type="passwordTypeConfirmNew"
              name="confirmNewPassword"
              :label="$t('ConfirmNewPassword')"
              :placeholder="$t('ConfirmNewPassword')"
              v-model:value.trim="confirmNewPassword"
              required
              validate

              validate-on-blur
              :minlength="6"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-password text-color-lightgray"></f7-icon>
            </template>
            <template #content-end>
              <div @click="switchVisability('passwordTypeConfirmNew')" class="margin-right link">
                <i class="f7-icons icon-view"
                   :class="{'text-color-gray' : passwordTypeConfirmNew === 'password', 'text-color-black' : passwordTypeConfirmNew === 'text'}"></i>
              </div>
            </template>
          </f7-list-input>
        </f7-list>
      </f7-tab>

    </f7-tabs>
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import { mapGetters } from "vuex";
import { getCountries, getTimeZones } from "../js/helpers";
import {QTAPI} from "../services/qt-api";

export default {
  name: "user-settings",

  props: {
    f7router: Object,
    f7route: Object,
  },

  data(){
    return {
      isLoading: false,
      currentTab: 'tab-user',
      customerName: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      countryCode: '',
      timeZone: '',
      address: '',
      address1: '',
      city: '',
      state: '',
      zipcode: '',

      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      passwordTypeCurrent: 'password',
      passwordTypeNew: 'password',
      passwordTypeConfirmNew: 'password',

      countryList: getCountries(),
      keyCountryList: 1,
      timeZonesList: getTimeZones(),
      keyTimeZonesList: 1,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfo'])
  },

  mounted() {
    this.customerName = this.UserInfo.CustomerName
    this.firstName = this.UserInfo.FirstName
    this.lastName = this.UserInfo.SurName
    this.email = this.UserInfo.Email
    this.phone = this.UserInfo.Mobile
    this.countryCode = this.UserInfo.CountryCode
    this.keyCountryList++
    this.timeZone = this.getSelectedTimeZone(this.UserInfo.TimeZoneID)
    this.keyTimeZonesList++
    this.address = this.UserInfo.Address0
    this.address1 = this.UserInfo.Address1
    this.city = this.UserInfo.Address2
    this.state = this.UserInfo.Address3
    this.zipcode = this.UserInfo.Address4

  },

  methods: {
    async onSubmitProfile(){
      let timezoneArr = this.timeZone.split('_')
      let data = {
        MinorToken: this.MinorToken,
        MajorToken: this.MajorToken,

        FirstName: this.firstName,
        SurName: this.lastName,
        Mobile: this.phone,
        Email: this.email,
        Address0: this.address,
        Address1: this.address1,
        Address2: this.city,
        Address3: this.state,
        Address4: this.zipcode,
        TimeZone: `${ timezoneArr[1] }_${ timezoneArr[0] }`,
      };
      this.isLoading = true
      let response = await QTAPI.AccountEdit(data)
      this.isLoading = false
      if (!response) {
        return
      }
      response.TimeZoneID = timezoneArr[0]
      this.$store.commit('SET_USER_INFO', {...this.UserInfo, ...response})
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('DataUpdated'),
      }).open()
      this.f7router.back()
    },
    async onSubmitPassword(){
      if(this.newPassword !== confirmNewPassword){
        f7.dialog.alert(this.$t('NewPasswordNotMatch'), this.$t('Error'))
        return
      }
      let data = {
        MinorToken: this.MinorToken,
        oldpwd: this.currentPassword,
        newpwd: this.newPassword,
      };
      this.isLoading = true

      let response = await QTAPI.ResetPassword(data)
      this.isLoading = false
      if (!response) {
        return
      }
      f7.dialog.alert(this.$t('PasswordChanged'), this.$t('Success'), () => {
        this.f7router.back()
        this.$store.dispatch('logout')
      })
    },
    getSelectedTimeZone(selected){
      let ret = this.timeZonesList[0]?.code
      if (selected) {
        let index = this.timeZonesList.findIndex( el => el.code.indexOf(selected) > -1 );
        if(index !== -1) {
          ret = this.timeZonesList[index].code
        }
      }
      return ret
    },
    switchVisability(name) {
      this[name] = this[name] === 'password' ? 'text' : 'password';
    },
  }
}
</script>

<style scoped>

</style>